import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Spinner from "../spinner/spinner-component";
import "./hb-index.css"
import BarChartIcon from "../bar-chart-icon/bar-chart-icon-component";


const HbIndex = (
  {
    loading,
    hbIndex,
    error,
    reportUrl
  }
) => {
  return (
    <div className="hb_index_container">
      {
        error && !loading
        ?
          <span>{ error }</span>
          :
          null
      }
      {
        !loading && !error ?
          <Fragment>
            <div className="hb_index_container__title">
              HX Index
            </div>
            <div className="hb_index_container__index">
              {Number(hbIndex).toFixed(3)}
            </div>
            <div className="hb_index_container__bar_chart_icon">
              <Link to={`/hb-index-chart?reportUrl=${reportUrl}`} style={{textDecoration: 'none'}}>
                <BarChartIcon />
              </Link>
            </div>
          </Fragment>
          :
          <Spinner
            loading={loading}
            left="110px"
            top="25px"
            fontSize="18px"
          />
      }
    </div>
  )
};

export default HbIndex;


// WEBPACK FOOTER //
// ./src/components/hb-index/hb-index-component.js